import * as React from 'react';

const DisableIcon = ({
	width = 80,
	height = 80,
	fill = 'black',
	color = '#545454',
	disabled = false,
	fillOpacity = 1,
	...props
}) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 60 74' fill='none' {...props}>
		<path
			d='M20 37H40M56.6667 40.3332C56.6667 56.9999 45 65.3332 31.1334 70.1665C30.4072 70.4126 29.6185 70.4008 28.9 70.1332C15 65.3332 3.33337 56.9999 3.33337 40.3332V16.9999C3.33337 16.1158 3.68456 15.268 4.30969 14.6428C4.93481 14.0177 5.78265 13.6665 6.66671 13.6665C13.3334 13.6665 21.6667 9.66654 27.4667 4.59987C28.1729 3.99653 29.0712 3.66504 30 3.66504C30.9289 3.66504 31.8272 3.99653 32.5334 4.59987C38.3667 9.69987 46.6667 13.6665 53.3334 13.6665C54.2174 13.6665 55.0653 14.0177 55.6904 14.6428C56.3155 15.268 56.6667 16.1158 56.6667 16.9999V40.3332Z'
			stroke={disabled ? '#0004' : color}
			stroke-width='6.67'
			stroke-linecap='round'
			stroke-linejoin='round'
		/>
	</svg>
);

export default DisableIcon;
